import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=379b57e6&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=ts"
export * from "./OurStory.vue?vue&type=script&lang=ts"
import style0 from "./OurStory.vue?vue&type=style&index=0&id=379b57e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b57e6",
  null
  
)

export default component.exports